import notificationService from './ws';

export default notificationService;